/** Formate une date ISO (ou toute chaîne parsable) en format court fr-FR ; "—" si absente/invalide. */
export function formatFrenchDate(value: unknown): string {
  if (value == null) return "—";
  if (typeof value === "string") {
    const d = Date.parse(value);
    if (!Number.isNaN(d)) return new Date(d).toLocaleDateString("fr-FR");
    return value;
  }
  return "—";
}
